import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { circularProgressSizeProps } from '@opengov/capital-mui-theme';
import { styles } from './LoadingPage.styles';

export function LoadingPage() {
  return (
    <Box data-test="loadingPage" sx={styles.container} component="main">
      <CircularProgress {...circularProgressSizeProps.large} />
    </Box>
  );
}
